import "core-js/actual/object/has-own";
import "core-js/actual/array/at";
import "core-js/actual/array/find-last";
import "core-js/actual/string/at";
import "core-js/actual/structured-clone";
import "wicg-inert";
import { installAbortCompatibility } from "./abort";
import { installUuidCompatibility } from "./uuid";
import { installFormCompatibility } from "./form";

// Run before evaluating any application or third-party component modules.
installAbortCompatibility();
installUuidCompatibility();
installFormCompatibility();
